import {ModuleWithProviders, NgModule} from "@angular/core";
import {DxUserBarComponent} from "./ui/components/user-bar/dx-user-bar.component";
import {DxUserInfoDirective} from "./ui/directives/user-bar/dx-user-info.directive";
import {DxSessionService} from "./services/dx-session.service";
import {DX_AUTH_CONFIG, DxAuthConfig} from "./config/dx-auth-config";
import {DxAuthService} from "./services/dx-auth.service";
import {DxLoginFormComponent} from "./ui/components/login-form/dx-login-form.component";
import {FormsModule} from "@angular/forms";
import {DxInMemoryStorageStrategy} from "./services/strategy/storage/dx-in-memory-storage-strategy";
import {DxBasicAuthenticationStrategy} from "./services/strategy/auth/dx-basic-authentication-strategy";
import {DxAuthGuard} from "./services/dx-auth-guard";
import {DxSessionStorageStrategy} from "./services/strategy/storage/dx-session-storage-strategy";
import {DxSyncLogoutStrategy} from "./services/strategy/logout/dx-sync-logout-strategy";
import {DxAsyncLogoutStrategy} from "./services/strategy/logout/dx-аsync-logout-strategy";
import {DxKeycloakAuthenticationStrategy} from "./services/strategy/auth/dx-keycloak-authentication-strategy";
import {DxKeycloakSessionRefreshStrategy} from "./services/strategy/session-refresh/dx-keycloak-session-refresh-strategy.service";
import {CommonModule} from "@angular/common";
import {DxBasicSessionRefreshStrategy} from "./services/strategy/session-refresh/dx-basic-session-refresh-strategy.service";
import {DxBasicValidationStrategy} from "./services/strategy/session-validation/dx-basic-validation-strategy";
import {DxRefreshTokenValidationStrategy} from "./services/strategy/session-validation/dx-refresh-token-validation-strategy";
import {DxLocalStorageStrategy} from "./services/strategy/storage/dx-local-storage-strategy";
import {DxServerDefinedValidationStrategy} from "./services/strategy/session-validation/dx-server-defined-validation-strategy";
import {DxServerDefinedSessionRefreshStrategy} from "./services/strategy/session-refresh/dx-server-defined-session-refresh-strategy.service";
import {DxServerDefinedAuthenticationStrategy} from "./services/strategy/auth/dx-server-defined-authentication-strategy";
import {DxServerStorageStrategy} from "./services/strategy/storage/dx-server-storage-strategy";


/**
 *  `DxAuthModule` - модуль предоставляет функциональность для аунтификации пользователей, по средствам:
 *  1. Basic auth
 *  2. JWT token
 *  3. Key cloak
 *  4. ...
 **/
@NgModule({
  declarations: [
    DxUserBarComponent,
    DxLoginFormComponent,
    DxUserInfoDirective
  ],
  exports: [
    DxUserBarComponent,
    DxLoginFormComponent,
    DxUserInfoDirective
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  providers: [
    DxSessionService,
    DxAuthService,
    DxInMemoryStorageStrategy,
    DxLocalStorageStrategy,
    DxSessionStorageStrategy,
    DxBasicAuthenticationStrategy,
    DxBasicSessionRefreshStrategy,
    DxBasicValidationStrategy,
    DxSyncLogoutStrategy,
    DxAsyncLogoutStrategy,
    DxKeycloakAuthenticationStrategy,
    DxKeycloakSessionRefreshStrategy,
    DxRefreshTokenValidationStrategy,
    DxServerDefinedValidationStrategy,
    DxServerDefinedSessionRefreshStrategy,
    DxServerDefinedAuthenticationStrategy,
    DxServerStorageStrategy,
    DxAuthGuard
  ],
  bootstrap: []
})
export class DxAuthModule {
  public static forRoot(config: DxAuthConfig | null | undefined): ModuleWithProviders {
    return {
      ngModule: DxAuthModule,
      providers: [
        {
          provide: DX_AUTH_CONFIG,
          useValue: config || {}
        },
        DxSessionService,
        DxAuthService,
        DxInMemoryStorageStrategy,
        DxSessionStorageStrategy,
        DxBasicAuthenticationStrategy,
        DxBasicSessionRefreshStrategy,
        DxBasicValidationStrategy,
        DxSyncLogoutStrategy,
        DxAsyncLogoutStrategy,
        DxKeycloakAuthenticationStrategy,
        DxKeycloakSessionRefreshStrategy,
        DxRefreshTokenValidationStrategy,
        DxServerDefinedValidationStrategy,
        DxServerDefinedSessionRefreshStrategy,
        DxServerDefinedAuthenticationStrategy,
        DxServerStorageStrategy,
        DxAuthGuard
      ]
    };
  }
}
